import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import App from './AppSearch';

export default class Root extends Component {
  render() {
    const { store, history, searchTerms, catId, subCatId, brandId, titleOverride, filter, isNonOemFirst, isSearch } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App searchTerms={searchTerms}
               catId={catId}
               subCatId={subCatId}
               brandId={brandId}
               titleOverride={titleOverride}
               filter={filter}
               isNonOemFirst={isNonOemFirst}
               isSearch={isSearch}
          />
        </ConnectedRouter>
      </Provider>
    );
  }
}

Root.propTypes = {
  searchTerms: PropTypes.string,
  catId: PropTypes.number,
  subCatId: PropTypes.number,
  brandId: PropTypes.number,
  titleOverride: PropTypes.string,
  filter: PropTypes.string,
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
